/* eslint-disable no-nested-ternary */
import React, {
  useEffect,
  useState,
} from 'react';
import {
  boxShadow,
  folderIcon,
  maxTablet,
  maxWidth,
  midWidthApp, primaryColor, primaryFont, primaryHeadingColor,
  retina,
  scrollbar,
  scrollbarX, secondaryFont, wMedium,
} from 'Utils/utilsStyle';
import {
  Divider,
  Radio,
} from 'antd';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  Folder,
} from 'Types/DocumentHubTypes';
import DocumentHubTableSkeleton from 'Components/common/skeleton/DocumentHubTableSkeleton';
import classNames from 'classnames';
import DownAngleIcon from 'Components/common/assets/svgIcons/DownAngleIcon';
import Empty from 'Components/common/assets/svgIcons/Empty';
import { useDispatch, useSelector } from 'react-redux';
import { selectFoldersPopupData } from 'Selector/DocumentHubSelector';
import { actions } from 'Slice/DocumentHubSlice';
import { getTimezoneInGMT } from 'Utils/UtilityFunctions';

const StyledWrapper = styled.div`
&.move-folder-table-wrapper {
  position: relative;
  padding: 10px 0px;
  .move-folder-inner-style-wrapper {
    .move-table-width-decide {
      @media all and (max-width: ${midWidthApp}) {
        min-width: calc(100vw + 50px);
      }
      .header-table {
        .table-item {
          &:nth-child(2) {
            padding-left: 63px;
          }
        }
      }
      .infinite-scroll-component__outerdiv {
        .infinite-scroll-component {
          display: flex;
          flex-direction: column;
          padding: 8px 32px;
          height: 504px !important;
          ${scrollbar};
          @media all and (max-width: ${maxWidth}), ${retina} {
            height: 328px !important;
          }
          .body-table {
            border: 2px solid #fff;
            &.active {
              border: 2px solid ${primaryColor};
              background: #ECFAF1;
            }
          }
          .document-hub-table-skelton-wrapper {
            padding: 0px;
          }
        }
      }
    }
  }
  .table-item {
    flex: 1 1 0%;
    &:first-child {
      min-width: 55px;
      max-width: 55px;
      @media all and (max-width :${maxWidth}), ${retina} {
        min-width: 55px;
        max-width: 55px;
      }
    }
    &:nth-child(2) {
      min-width: calc(100% - 582px);
      max-width: calc(100% - 582px);
      @media all and (max-width :${maxWidth}), ${retina} {
        min-width: calc(100% - 482px);
        max-width: calc(100% - 482px);
      }
    }
    .table-item-file-name {
      padding-left: 0px;
    }
  } 
}  
  `;

const InnerStyleWrapper = styled.div`
  @media all and (max-width: ${midWidthApp}) { 
    overflow-x: scroll;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    ${scrollbarX};
    padding: 0 10px;
    .table-item {
      @media all and (max-width: ${maxTablet}) {
        min-width: 200px;
        &:first-child {
          min-width: 380px;
          max-width: 380px;
        }
      }
    }
  }
`;
const InnerTable = styled.div``;

const TableHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 32px;
  border: 2px solid rgb(255, 255, 255);
  .table-item {
    position: relative;
    padding: 10px 5px;
    &:first-child {
      .heading-div {
        padding-left: 88px;
      }
    }
    .heading-div {
      &.actionHeading {
        cursor: pointer;
        width: fit-content;
      }
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .heading-text {
        cursor: pointer;
        font-family: ${primaryFont};
        font-size: 16px;
        font-weight: ${wMedium};
        line-height: 18px;
        letter-spacing: -0.333px;
        color: #5E7079;
        margin-bottom: 0px;
      }
      .action-div {
        display: flex;
        flex-direction: column;
        margin-left: 5px;
        svg {
          width: 8px;
          height: 8px;
          cursor: pointer;
          &:first-child {
            transform: rotate(180deg);
            margin-bottom: 1px;
          }
        }
      }
    }
  }
  `;

const TableBody = styled.div`
  display: flex;
  align-items: center;
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #FFF;
  width: 100%;
  margin-bottom: 8px;
  border: 1px solid #fff;
  height: 80px;
  &.active {
    border: 1px solid${primaryColor};
  }
  .table-item {
    text-align: start;
    position: relative;
    padding: 20px 5px;
    .ant-radio-wrapper {
      margin: 0 0px 0px 10px;
    }
    .date-time-div {
      display: flex;
      align-items: center;
      width: 100%;
      .text-date{
        width: unset;
        line-height: 15px;
        &.fileSize {
          font-size: 14px;
          line-height: 20px;
        }
      }
      .ant-divider {
        border-left: 1px solid ${primaryHeadingColor};
      }
    }
  }
  `;

const FileName = styled.div`
  display: flex;
  align-items: center;
  padding-left: 32px;
  .file-img {
    width: 36px;
    min-width: 36px;
    height: 40px;
    margin-right: 20px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 30px;
      min-width: 30px;
      height: 34px;
      margin-right: 25px;
    }
  }
  .file-name-size-div {
    display: flex;
    flex-direction: column;
    width: calc(100% - 55px);
  }
  .file-name-desktop {
    font-family: ${secondaryFont};
    font-size: 20px;
    font-weight: ${wMedium};
    line-height: 24px;
    letter-spacing: -0.417px;
    color: #000;
    margin-bottom: 0px;
    text-align: left;
    cursor: default;
  }
  .highlighted {
    color: ${primaryColor};
    text-decoration: underline;
    &:hover {
      text-decoration: underline;
    }
  }
  `;

const FileInfoText = styled.span`
  font-family: ${primaryFont};
  font-size: 16px;
  font-weight: ${wMedium};
  line-height: 24px; 
  letter-spacing: -0.375px;
  color: ${primaryHeadingColor};
  width: 100%;
`;

const tableHeader = [
  {
    title: 'Name',
    type: 'name',
    sortType: 'name',
  },
  {
    title: 'Uploaded by',
    type: 'uploadedBy',
    sortType: 'createdBy',
  },
  {
    title: 'Date/Time',
    type: 'date',
    sortType: 'lastModified',
  },
];

const MoveFolderDocumentTable = function MoveFolderDocumentTable() {
  const dispatch = useDispatch();
  const timezone = getTimezoneInGMT();

  const {
    visible, folders, ended, loading, sortType, searchTerm, selectedFolder,
  } = useSelector(selectFoldersPopupData);

  const [tableRowId, setTableRowId] = useState<number | null>();

  const onRadioClick = (folder: Folder) => {
    dispatch(actions.setFoldersPopupSelectedFolder(folder));
  };

  const onNext = () => {
    fetchMoreFolders();
  };

  const onSortClick = (type: string) => {
    if (!loading) {
      dispatch(actions.toggleFoldersPopupSorting(type));
    }
  };

  const fetchMoreFolders = () => {
    if (visible) {
      dispatch(actions.getFolders({
        offset: folders.length ?? 0,
        limit: 20,
        sortingType: sortType,
        timezone,
        ...searchTerm?.length && { searchTerm },
        onlyFolder: true,
      }));
    }
  };

  useEffect(() => {
    fetchMoreFolders();
  }, [sortType, searchTerm, visible]);

  return (
    <StyledWrapper className={classNames('move-folder-table-wrapper')}>
      <InnerStyleWrapper className="move-folder-inner-style-wrapper">
        <InnerTable className="move-table-width-decide">
          <TableHeader className="header-table">
            <span className="table-item">
              <Empty />
            </span>
            {tableHeader?.map((heading) => (
              <span className="table-item">
                <div className="heading-div">
                  <span
                    className="heading-text"
                    onClick={() => onSortClick(heading.sortType)}
                    onKeyDown={() => onSortClick(heading.sortType)}
                    role="button"
                    tabIndex={0}
                  >
                    {heading.title}
                  </span>
                  <div
                    className="action-div"
                    onClick={() => onSortClick(heading.sortType)}
                    onKeyDown={() => onSortClick(heading.sortType)}
                    role="button"
                    tabIndex={0}
                  >
                    <DownAngleIcon color={sortType.includes('asc') && sortType.includes(heading.sortType) ? primaryColor : '#5E7079'} />
                    <DownAngleIcon color={sortType.includes('desc') && sortType.includes(heading.sortType) ? primaryColor : '#5E7079'} />
                  </div>
                </div>
              </span>
            ))}
          </TableHeader>
          <InfiniteScroll
            dataLength={folders.length}
            next={onNext}
            hasMore={!ended}
            loader={false}
            className={classNames('o-x-hidden')}
            height="auto"
          >
            {folders.map((folder) => {
              const {
                name, createdBy, date, time,
                id, isSelected, isDelegateAdmin, isAdmin, isOwner, isSharedFolder, editAccess,
              } = folder;
              return (
                <TableBody className={classNames('body-table', { active: (tableRowId === id) || isSelected })}>
                  <span className={classNames('table-item')}>
                    <Radio onClick={() => onRadioClick(folder)} checked={id === selectedFolder?.id} disabled={!isSharedFolder && !isAdmin && !isDelegateAdmin && !isOwner && editAccess !== 1} />
                  </span>
                  <span className="table-item">
                    <FileName className="table-item-file-name">
                      <img
                        src={folderIcon}
                        alt="file-type-icon"
                        className={classNames('file-img')}
                      />
                      <div className="file-name-size-div">
                        <span
                          className={classNames('file-name-desktop  text-truncate-one-line', { highlighted: tableRowId === id })}
                        >
                          {name}
                        </span>
                      </div>
                    </FileName>
                  </span>
                  <span className="table-item">
                    <FileInfoText className={classNames('text-truncate-one-line')}>{createdBy}</FileInfoText>
                  </span>
                  <span className="table-item">
                    <div className="date-time-div">
                      <FileInfoText
                        className={classNames('text-date', 'text-truncate-one-line')}
                      >
                        {date}
                      </FileInfoText>
                      <Divider type="vertical" />
                      <FileInfoText
                        className={classNames('text-date', 'text-truncate-one-line')}
                      >
                        {time}
                      </FileInfoText>
                    </div>
                  </span>
                </TableBody>
              );
            })}
            {
              loading ? <DocumentHubTableSkeleton /> : null
            }
          </InfiniteScroll>
        </InnerTable>
      </InnerStyleWrapper>
    </StyledWrapper>
  );
};

export default MoveFolderDocumentTable;
